import script from "./topicComment.vue?vue&type=script&setup=true&lang=js"
export * from "./topicComment.vue?vue&type=script&setup=true&lang=js"

import "./topicComment.vue?vue&type=style&index=0&id=c8993b12&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8993b12"]])

export default __exports__